/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.UploadKeywords";
        class UploadKeywordsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("UploadKeywordsWidgetTypeClass.createInstance()");
                    return new UploadKeywordsWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("UploadKeywordsWidgetTypeClass._storeHtml()");
                    UploadKeywordsWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("UploadKeywordsWidgetTypeClass::constructor");
                if (UploadKeywordsWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/UploadKeywords/upload-keywords.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.UploadKeywordsWidgetTypeClass = UploadKeywordsWidgetTypeClass;
        class UploadKeywordsWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._outerDiv = null;
                this._stealthHideButton = null;
                this._editContainer = null;
                this._clearButton = null;
                this._kwComponentContainer = null;
                this._kwComponent = null;
                // State info
                this._collapseState = "Show";
                this._currentDocTypeId = 0;
                this.presentInstance = () => {
                    this._log.info("UploadKeywordsWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = UploadKeywordsWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._kwComponentContainer = this._container.querySelector('#uploadKeysKeywordsComponent');
                    this._stealthHideButton = this._container.querySelector('#uploadKeysStealthButton');
                    this._stealthHideButton.addEventListener('click', this._stealthHide);
                    this._core.Helper.setElementTranslationAttribute(this._stealthHideButton, 'title', 'STR_WPT_HIDE');
                    // Edit controls
                    this._editContainer = this._container.querySelector('#uploadKeysEditControls');
                    this._clearButton = this._container.querySelector('#uploadKeysClearBtn');
                    this._clearButton.addEventListener('click', this.clearFields);
                    this._core.Helper.setElementTranslation(this._clearButton.querySelector('#uploadKeysClearBtnLabel'), 'STR_WPT_CLEAR');
                    this._widgets.setTitle(this._config, this._container.querySelector('#uploadKeysHeading'), 'STR_WPT_KEYWORDS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    // Set up component
                    //let config: UploadKeywordsWidgetInstanceConfig = <UploadKeywordsWidgetInstanceConfig>this._config;
                    if (this._collapseState == "Stealth")
                        this._core.Functions.showElement(this._stealthHideButton);
                    this._kwComponent = new Widgets.ComponentKeywordsUpload(this._core, this._kwComponentContainer, this);
                    this._kwComponent.ErrorCallback = this._callErrorHandler;
                    this._kwComponent.FailCallback = this._callFailedHandler;
                    this._kwComponent.present();
                    this._type.instanceReady(this.getHandle());
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("UploadKeywordsWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("UploadKeywordsWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this.clearFields = () => {
                    this._log.info("UploadKeywordsWidgetInstanceClass.clearFields()");
                    this._showKeysForDocType(this._currentDocTypeId);
                };
                this._stealthHide = (event) => {
                    this._log.info("UploadKeywordsWidgetInstanceClass._stealthHide()");
                    this._core.Functions.hideElement(this._outerDiv);
                };
                this._showKeysForDocType = (docTypeId) => {
                    this._log.info("UploadKeywordsWidgetInstanceClass._showKeysForDocType()");
                    this._currentDocTypeId = docTypeId;
                    let request = {
                        DocTypes: [this._core.OBHelper.DocumentTypesById[docTypeId].Name]
                    };
                    this._kwComponent.makeRequest(request);
                    this._core.Functions.showElement(this._editContainer);
                };
                this.clearDisplay = () => {
                    this._log.info("UploadKeywordsWidgetInstanceClass.clearDisplay()");
                    this._kwComponent.clearDisplay();
                    this._core.Functions.hideElement(this._editContainer);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("UploadKeywordsWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                this._log.info("UploadKeywordsWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                // Don't respond to update events, we are directy working for another widget
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCTYPE_SELECTED_UPLOAD:
                        if ((this._collapseState == "Stealth") && this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS) && context.Decloak)
                            this._core.Functions.showElement(this._outerDiv);
                        if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS))
                            this._showKeysForDocType(context.ActivationID);
                        // this._core.Functions.hideElement(this._clearEntriesButton);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCTYPE_DESELECTED:
                        this.clearDisplay();
                        if (this._collapseState == "Stealth")
                            this._core.Functions.hideElement(this._outerDiv);
                        // this._core.Functions.hideElement(this._clearEntriesButton);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.REQUEST_DOC_UPLOAD_INFO:
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_UPLOAD_KEYWORDS);
                        navEvent.ActivationID = 0;
                        if (this._kwComponent.Valid) {
                            navEvent.PrimaryContext = this._kwComponent.KeywordRecords;
                            navEvent.AdditionalContext["KeywordsValid"] = true;
                            // Properties come as pseudo-keywords
                            let docDateKW = this._kwComponent.Properties.find(prop => (prop.Name == '>>DocumentDate'));
                            if (docDateKW)
                                navEvent.AdditionalContext['>>DocumentDate'] = docDateKW.Value;
                        }
                        else {
                            navEvent.PrimaryContext = null;
                            navEvent.AdditionalContext["KeywordsValid"] = false;
                        }
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                        break;
                }
            }
        }
        UploadKeywordsWidgetInstanceClass.HtmlData = null;
        Widgets.UploadKeywordsWidgetInstanceClass = UploadKeywordsWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
